const apiKeys = {
  firebaseConfig: {
    apiKey: "AIzaSyBSbgzhMkJ4FTXaW2w5eyoc7ua_6fR3_H8",
    authDomain: "get-roasted-228b6.firebaseapp.com",
    databaseURL: "https://get-roasted-228b6.firebaseio.com",
    projectId: "get-roasted-228b6",
    storageBucket: "get-roasted-228b6.appspot.com",
    messagingSenderId: "145961091682"
  },
  weatherbitKeys: {
  apiKey: '65a5a3072f4a4424a544b6461455fe14',
  }
};



export default apiKeys ;